{
    "Accessibility menu": "Menu Aksesibiliti",
    "Close": "Tutup",
    "Content adjustments": "Penyesuaian Kandungan",
    "Navigation adjustments": "Penyesuaian Navigasi",
    "Text Align": "Penjajaran Teks",
    "Align Left": "Jajar ke Kiri",
    "Align Center": "Jajar Tengah",
    "Align Right": "Jajar Kanan",
    "Adjust Font Size": "Laraskan Saiz Fon",
    "Highlight Title": "Serlahkan Tajuk",
    "Highlight Links": "Serlahkan Pautan",
    "Readable Font": "Fon Mudah Baca",
    "Colour adjustments": "Penyesuaian Warna",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Tools": "Peralatan",
    "Reading Guide": "Panduan Membaca",
    "Big Cursor": "Kursor Besar",
    "Increase Font Size": "Besarkan Saiz Fon",
    "Decrease Font Size": "Kecilkan Saiz Fon",
    "Letter Spacing": "Jarak Huruf",
    "Line Height": "Ketinggian Baris",
    "Font Weight": "Ketebalan Fon",
    "Dyslexia Font": "Fon Disleksia",
    "Language": "Bahasa",
    "Accessibility widget": "Buka menu kebolehcapaian",
    "Accessibility Profiles": "Profil Kebolehcapaian",
    "Cognitive Disability": "Kecacatan Kognitif",
    "Seizure Safe": "Selamat untuk Epilepsi",
    "Accessibility statement": "Pernyataan Kebolehcapaian",
    "ADHD": "ADHD",
    "Low Vision": "Penglihatan Rendah",
    "Pause Animations": "Hentikan Animasi",
    "Animation paused": "Animasi dijeda",
    "Reset all settings": "Tetapkan semula tetapan",
    "Shortcut:": "Pintasan:",
    "Epilepsy Safe Mode": "Mod Selamat Epilepsi",
    "Mute sounds": "Bisukan bunyi",
    "Page read": "Baca halaman",
    "Page read controls": "Kawalan baca halaman",
    "Pause": "Jeda",
    "Resume": "Sambung semula",
    "Stop": "Henti",
    "Settings": "Tetapan",
    "Speed": "Kelajuan",
    "Voice": "Suara",
    "Close accessibility menu": "Tutup menu kebolehcapaian",
    "Back to accessibility menu": "Kembali ke menu kebolehcapaian",
    "Search languages": "Cari bahasa",
    "Selected language": "Bahasa yang dipilih",
    "View accessibility statement (opens in new window)": "Lihat pernyataan kebolehcapaian (dibuka dalam tetingkap baharu)",
    "Visit CookieYes website (opens in new window)": "Lawati laman web CookieYes (dibuka dalam tetingkap baharu)",
    "Reset all accessibility settings to default": "Tetapkan semula semua tetapan kebolehcapaian kepada lalai"
}
